import "./_asset-name.scss";

import classNames from "classnames";

import TruncatedText from "../../component/truncated-text/TruncatedText";
import {getAssetId} from "../util/assetUtils";
import {Asset} from "../util/assetModels";
import {TypographyProps} from "../../component/typography/Typography";
import {useVerifiedAssets} from "../verified/context/VerifiedAssetContext.utils";
import AssetVerificationBadge from "../verification-badge/AssetVerificationBadge";

interface AssetNameProps {
  asset: Pick<Asset, "name" | "id" | "unit_name" | "clawback_address">;
  charLimit?: number;
  nameType?: "default" | "unit";
  customClassName?: string;
  typography?: TypographyProps<"div">["variant"];
}

export const DEFAULT_ASSET_NAME_CHAR_LIMIT = 21;

function AssetName({
  asset,
  charLimit = DEFAULT_ASSET_NAME_CHAR_LIMIT,
  nameType = "default",
  typography = "body",
  customClassName
}: AssetNameProps) {
  const verifiedAssets = useVerifiedAssets();
  const assetId = getAssetId(asset);
  const verificationData = verifiedAssets[assetId];

  return (
    <div className={classNames("is-vertically-centered asset-name", customClassName)}>
      <TruncatedText
        typographyProps={{
          customClassName: "asset-name__name",
          variant: typography
        }}
        text={nameType === "unit" ? asset.unit_name : asset.name}
        charLimit={charLimit}
      />

      <AssetVerificationBadge
        assetId={String(assetId)}
        verificationTier={verificationData?.verification_tier || "unverified"}
      />
    </div>
  );
}

export default AssetName;
